const CardSchema = {
  title: 'Card (Semantic UI)',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['stackable', 'itemsPerRow', 'items'],
    },
  ],

  properties: {
    stackable: {
      title: 'Stackable',
      description: 'Forces cards into a single-column stack on mobile layouts',
      type: 'boolean',
      default: true,
    },

    itemsPerRow: {
      title: 'Cards Per Row',
      type: 'number',
      default: 3,
    },

    items: {
      title: 'Cards',
      widget: 'object_list',
      schema: {
        title: 'Card',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: [
              'image',
              'imageFloated',
              'header',
              'meta',
              'description',
              'icon',
              'extraText',
              'link',
            ],
          },
        ],

        properties: {
          image: {
            title: 'Image',
            type: 'string',
            widget: 'image',
          },

          imageFloated: {
            title: 'Image Floated',
            type: 'boolean',
            description: 'Floats the image to the right, and makes it small',
          },

          header: {
            title: 'Header',
            type: 'string',
          },

          meta: {
            title: 'Meta',
            type: 'string',
          },

          description: {
            title: 'Description',
            widget: 'textarea',
            type: 'string',
          },

          icon: {
            title: 'Icon',
            type: 'string',
            description: 'Accepts any Semantic UI icon name',
          },

          extraText: {
            title: 'Extra Text',
            type: 'string',
            description: 'Adds text to the card footer',
          },

          link: {
            title: 'Link',
            widget: 'object_browser',
            mode: 'link',
            selectableTypes: ['Document'],
          }
        },

        required: ['title'],
      },
    },
  },

  required: ['items'],
};

export default CardSchema;
